import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material'
import { isEqual } from 'lodash'
import dayjs from 'dayjs'
import { TextField } from 'formik-material-ui'
import { Field, Form, Formik } from 'formik'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import CloseIcon from '@mui/icons-material/Close'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import DateTimeField from '../../../components/DateTimeField/DateTimeField'

const retornaDados = (u = []) => ({
  idConta: u?.[0] || '',
  nrDocumento: u?.[5] || '',
  dsConta: u?.[7] || '',
  dtPagamento: u?.[14] || '',
  vlConta: u?.[15] || '',
  vlQuitacao: u?.[17] || '',
  idFormaPagamento: null,
  acFormaPagamento: null,
  idEmpresa: u?.[3]?.[0]?.[0] || null,
  acEmpresa: u?.[3] || null,
  idCentroCusto: u?.[20]?.[0]?.[0] || null,
  acCentroCusto: u?.[20] || null,
})

export const ModalContaAReceberConfirmacao = ({
  show,
  handleClose,
  dados,
  setRefresh,
}) => {
  const formato = 'YYYY-MM-DD HH:mm:ss'

  const salva = async (values) => {
    const dataVencimento = dayjs(values.dtPagamento)
    if (!dataVencimento.isValid()) {
      values.dtPagamento = undefined
    } else {
      values.dtPagamento = dataVencimento.format(formato)
    }

    values.idEmpresa = values.acEmpresa?.[0]?.[0] || null
    values.idCentroCusto = values.acCentroCusto?.[0]?.[0] || null

    const res = await metodoPrograma('salvaPagamento', values)
    if (res.status) {
      setRefresh((prev) => prev + 1)
      handleClose(false)
    }
  }

  return (
    <Formik
      initialValues={retornaDados(dados)}
      enableReinitialize
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        await salva(values)
        setSubmitting(false)
        resetForm()
      }}
    >
      {({ isSubmitting, submitForm, values, setFieldValue }) => (
        <Form>
          <Dialog
            open={show}
            aria-label="close"
            keepMounted
            handleClose={handleClose}
            fullWidth={true}
            maxWidth={'lg'}
            md={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>Confirmação de Recebimento</DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    name="nrDocumento"
                    label="Nro Documento"
                    disabled
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    name="dsConta"
                    label="Nome da Conta"
                    disabled
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <CurrencyField
                    InputLabelProps={{ shrink: true }}
                    name="vlConta"
                    label="Valor"
                    fullWidth
                    disabled={values.dtRecebimento}
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.vlConta}
                    onChange={(v) => {
                      setFieldValue('vlConta', v)
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Empresa"
                    metodo="buscaEmpresa"
                    value={values.acEmpresa}
                    onChange={(_, v) => {
                      setFieldValue('idEmpresa', v?.[0]?.[0])
                      setFieldValue('acEmpresa', v)
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Centro de Custo"
                    metodo="buscaCentroCusto"
                    value={values.acCentroCusto}
                    onChange={(_, v) => {
                      setFieldValue('idCentroCusto', v?.[0]?.[0])
                      setFieldValue('acCentroCusto', v)
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <DateTimeField
                    InputLabelProps={{ shrink: true }}
                    name="dtPagamento"
                    label="Data de Pagamento"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.dtPagamento || null}
                    onChange={(v) => setFieldValue('dtPagamento', v)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Forma de Recebimento"
                    metodo="buscaFormaPagamento"
                    value={values.acFormaPagamento}
                    onChange={(_, v) => {
                      setFieldValue('idFormaPagamento', v?.[0]?.[0])
                      setFieldValue('acFormaPagamento', v)
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <CurrencyField
                    InputLabelProps={{ shrink: true }}
                    name="vlQuitacao"
                    label="Valor Pago"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.vlQuitacao}
                    onChange={(v) => {
                      setFieldValue('vlQuitacao', v)
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  )
}

export default memo(ModalContaAReceberConfirmacao, isEqual)
